import React from 'react'
import styled from '@emotion/styled'
import { space, color } from '@ticketswap/solar'
import { Facebook, Twitter, Envelope } from '@ticketswap/comets'

const Item = styled.li`
  display: inline-block;

  & + ${() => Item} {
    margin-left: ${space[8]};
  }
`

const Button = styled.button`
  display: inline-block;
  line-height: 1.75;
  outline: 0;
  color: white;
  vertical-align: middle;
  width: ${space[32]};
  height: ${space[32]};
  border-radius: ${space[16]};
  text-align: center;
  background-color: ${props => (props.bgColor ? props.bgColor : color.earth)};
`

export function windowPopup(url, width, height) {
  if (typeof window === 'undefined') return false
  const top = window.innerHeight / 2 - height / 2
  const left = window.innerWidth / 2 - width / 2

  // eslint-disable-next-line
  return window.open(
    url,
    '',
    `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`
  )
}

const SharingWidget = ({ name, uri }) => {
  if (!uri.url) return null

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    uri.url
  )}?utm_campaign=eventShare&utm_source=facebook&utm_medium=SharedFacebook`
  const tweet = `${name} - Buy and sell tickets – TicketSwap`
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    tweet
  )}&url=${encodeURIComponent(
    uri.url
  )}?utm_campaign=eventShare&utm_source=twitter&utm_medium=SharedTwitter`
  const emailSubject = 'Check out this link on TicketSwap'
  const emailBody = encodeURIComponent(
    `${name} ${uri.url}?utm_campaign=eventShare&utm_source=email&utm_medium=sharedMail`
  )

  return (
    <ul>
      <Item>
        <Button
          bgColor={color.facebook}
          onClick={() => windowPopup(facebookUrl, 500, 300)}
        >
          <Facebook size={24} />
        </Button>
      </Item>
      <Item>
        <Button
          bgColor="#1da1f2"
          onClick={() => windowPopup(twitterUrl, 500, 300)}
        >
          <Twitter size={24} />
        </Button>
      </Item>
      <Item>
        <Button
          as="a"
          href={`mailto:?subject=${emailSubject}&body=${emailBody}`}
        >
          <Envelope size={24} />
        </Button>
      </Item>
    </ul>
  )
}

SharingWidget.defaultProps = {
  name: '',
  uri: {},
}

export default SharingWidget
